import React from "react";
import { Space } from "antd";
import {
  AxDropdown,
  AxMenu,
  AxIconWrapper,
  AxButton,
  AxCollapse,
  AxSideMenu,
  AxDivider,
  AxSearch,
} from "@dynata/axiom3";

const { Panel } = AxCollapse;

const header = (
  <div>
    <span className="title semibold s" style={{ paddingRight: "15px" }}>
      Contents
    </span>
    <span>
      <AxDropdown
        overlay={
          <AxMenu>
            <AxMenu.Item key="0">
              <AxIconWrapper type="regular" size="16" icon={"fa-user"} />
              List Item
            </AxMenu.Item>
            <AxMenu.Item key="1">
              <AxIconWrapper type="regular" size="16" icon={"fa-user"} />
              List Item
            </AxMenu.Item>
          </AxMenu>
        }
        trigger={["click"]}
        placement="topLeft"
      >
        <AxButton
          size="small"
          color="blue"
          type="dropdown"
          style={{ height: "auto" }}
        >
          filter
          <AxIconWrapper type="solid" size="14" icon={"fa-angle-down"} />
        </AxButton>
      </AxDropdown>
    </span>
  </div>
);

class SideMenu extends React.Component {
  render() {
    return (
      <div className="section table" id="sidemenu">
        <h3>Side Menu</h3>
        <p>A side menu component for navigation.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space size="large" direction="vertical">
          <pre>
            {`
<AxSideMenu>
  <AxSideMenu.SideMenuItem menuId="1" icon="fa-book-open">
    ...
  </AxSideMenu.SideMenuItem>
  <AxSideMenu.SideMenuItem menuId="2" icon="fa-book-open">
    ...
  </AxSideMenu.SideMenuItem>
</AxSideMenu>
            `}
          </pre>

          <div className="prop-header">
            <p className="props-title">Props</p>
          </div>
          <table className="props-table">
            <tbody>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Value</th>
              </tr>
              <tr>
                <td>defaultSelectedMenuId</td>

                <td>Default is, null.</td>
                <td>string</td>
              </tr>
              <tr>
                <td>orientation</td>
                <td>Default is, left</td>
                <td>left | right</td>
              </tr>
              <tr>
                <td>mini</td>
                <td>To render a minified version without the pane.</td>
                <td>boolean</td>
              </tr>
              <tr>
                <td>destroyInactiveMenuItem</td>
                <td>
                  If true, destroys inactive SideMenuItem. Default is, false.
                </td>
                <td>boolean</td>
              </tr>
              <tr>
                <td>onMenuChanged</td>
                <td>
                  Callback function that executes when a menu item is selected.
                </td>
                <td>(SideMenuItem.menuId) =&gt; void</td>
              </tr>
              <tr>
                <td>onCloseClick</td>
                <td>
                  Set the handler to handle the click event for the collapse menu button.
                </td>
                <td>(void) =&gt; void</td>
              </tr>

              <tr>
                <td>selectedMenuId</td>
                <td>
                  Manually set the selected menu's id; set <code>null</code> to
                  collapse.
                </td>
                <td>string</td>
              </tr>

              <tr>
                <td>onMenuClick</td>
                <td>
                  Callback function that executes when a menu is selected.
                </td>
                <td>(menuId: string) =&gt; void</td>
              </tr>

              <tr>
                <td>children</td>
                <td>Required</td>
                <td>AxSideMenu.SideMenuItem | [AxSideMenu.SideMenuItem]</td>
              </tr>

              <tr>
                <td>closeStyles</td>
                <td>Custom styles for close button</td>
                <td>Object</td>
              </tr>
            </tbody>
          </table>

          <div className="prop-header">
            <p className="props-title">Props: AxSideMenu.SideMenuItem</p>
          </div>
          <table className="props-table">
            <tbody>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Value</th>
              </tr>
              <tr>
                <td>menuId</td>
                <td>Required</td>
                <td>string</td>
              </tr>
              <tr>
                <td>icon</td>
                <td>Required</td>
                <td>string</td>
              </tr>

              <tr>
                <td>header</td>
                <td>Header element for SideMenuItem</td>
                <td>ReactNode</td>
              </tr>
            </tbody>
          </table>
        </Space>

        <AxDivider orientation="left" plain>
          Example
        </AxDivider>
        <Space size="large" direction="vertical">
          <pre>
            {`
const header = (
  <div>
    <span className="title semibold s" style={{ paddingRight: "15px" }}>
      Contents
    </span>
    <span>
      <AxDropdown
        overlay={
          <AxMenu>
            <AxMenu.Item key="0">
              <AxIconWrapper type="regular" size="16" icon={"fa-user"} />
              List Item
            </AxMenu.Item>
            <AxMenu.Item key="1">
              <AxIconWrapper type="regular" size="16" icon={"fa-user"} />
              List Item
            </AxMenu.Item>
          </AxMenu>
        }
        trigger={["click"]}
        placement="topLeft"
      >
        <AxButton
          size="small"
          color="blue"
          type="dropdown"
          style={{ height: "auto" }}
        >
          filter
          <AxIconWrapper type="solid" size="14" icon={"fa-angle-down"} />
        </AxButton>
      </AxDropdown>
    </span>
  </div>
);

<AxSideMenu defaultSelectedMenuId="1" paneWidth={300}>
<AxSideMenu.SideMenuItem menuId="1" icon="fa-book-open" header={header}>
  <div style={{ margin: "18px 0" }}>
    <AxSearch placeholder="Search" />
  </div>

  <AxCollapse defaultActiveKey={["1"]} ghost>
    <Panel header="Section Title" key="1">
      <ul>
        <li>
          <AxButton color="primary" type="link">
            1. Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="neutral" type="link">
            2. Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="danger" type="link">
            3. Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="primary" type="link">
            4. Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="primary" type="link">
            5. Menu Item
          </AxButton>
        </li>
      </ul>
    </Panel>
    <Panel header="Section Title" key="2">
      <ul>
        <li>
          <AxButton color="primary" type="link">
            <AxIconWrapper type="regular" size="12" icon={"fa-star"} />{" "}
            Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="neutral" type="link">
            <AxIconWrapper type="regular" size="12" icon={"fa-star"} />{" "}
            Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="danger" type="link">
            <AxIconWrapper type="regular" size="12" icon={"fa-star"} />{" "}
            Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="primary" type="link">
            <AxIconWrapper type="regular" size="12" icon={"fa-star"} />{" "}
            Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="primary" type="link">
            <AxIconWrapper type="regular" size="12" icon={"fa-star"} />{" "}
            Menu Item
          </AxButton>
        </li>
      </ul>
    </Panel>
    <Panel header="Section Title" key="3">
      <ul>
        <li>
          <AxButton color="primary" type="link">
            Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="neutral" type="link">
            Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="danger" type="link">
            Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="primary" type="link">
            Menu Item
          </AxButton>
        </li>
        <li>
          <AxButton color="primary" type="link">
            Menu Item
          </AxButton>
        </li>
      </ul>
    </Panel>
  </AxCollapse>
</AxSideMenu.SideMenuItem>
<AxSideMenu.SideMenuItem menuId="2" icon="fa-book-open">
  <h5>Second Menu</h5>
</AxSideMenu.SideMenuItem>
</AxSideMenu>            
            `}
          </pre>
          <div>
            <AxSideMenu defaultSelectedMenuId="1" paneWidth={300}>
              <AxSideMenu.SideMenuItem
                menuId="1"
                icon="fa-book-open"
                header={header}
              >
                <div style={{ margin: "18px 0" }}>
                  <AxSearch placeholder="Search" />
                </div>

                <AxCollapse defaultActiveKey={["1"]} ghost>
                  <Panel header="Section Title" key="1">
                    <ul>
                      <li>
                        <AxButton color="primary" type="link">
                          1. Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="neutral" type="link">
                          2. Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="danger" type="link">
                          3. Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="primary" type="link">
                          4. Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="primary" type="link">
                          5. Menu Item
                        </AxButton>
                      </li>
                    </ul>
                  </Panel>
                  <Panel header="Section Title" key="2">
                    <ul>
                      <li>
                        <AxButton color="primary" type="link">
                          <AxIconWrapper
                            type="regular"
                            size="12"
                            icon={"fa-star"}
                          />{" "}
                          Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="neutral" type="link">
                          <AxIconWrapper
                            type="regular"
                            size="12"
                            icon={"fa-star"}
                          />{" "}
                          Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="danger" type="link">
                          <AxIconWrapper
                            type="regular"
                            size="12"
                            icon={"fa-star"}
                          />{" "}
                          Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="primary" type="link">
                          <AxIconWrapper
                            type="regular"
                            size="12"
                            icon={"fa-star"}
                          />{" "}
                          Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="primary" type="link">
                          <AxIconWrapper
                            type="regular"
                            size="12"
                            icon={"fa-star"}
                          />{" "}
                          Menu Item
                        </AxButton>
                      </li>
                    </ul>
                  </Panel>
                  <Panel header="Section Title" key="3">
                    <ul>
                      <li>
                        <AxButton color="primary" type="link">
                          Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="neutral" type="link">
                          Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="danger" type="link">
                          Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="primary" type="link">
                          Menu Item
                        </AxButton>
                      </li>
                      <li>
                        <AxButton color="primary" type="link">
                          Menu Item
                        </AxButton>
                      </li>
                    </ul>
                  </Panel>
                </AxCollapse>
              </AxSideMenu.SideMenuItem>
              <AxSideMenu.SideMenuItem menuId="2" icon="fa-book-open">
                <h5>Second Menu</h5>
              </AxSideMenu.SideMenuItem>
            </AxSideMenu>
          </div>

          <AxDivider orientation="left" plain>
            Mini
          </AxDivider>
          <pre>
            {`
<AxSideMenu
 mini={true}
 orientation="right"
 customLogo={<div style={{ padding: "8px 0" }}>logo</div>}
>
 <AxSideMenu.SideMenuItem menuId="1">
   <AxIconWrapper type="regular" size="20" icon={"fa-star"} />
 </AxSideMenu.SideMenuItem>
 <AxSideMenu.SideMenuItem menuId="2">
   <AxIconWrapper type="regular" size="20" icon={"fa-star"} />
 </AxSideMenu.SideMenuItem>
</AxSideMenu>
            `}
          </pre>

          <div>
            <AxSideMenu
              mini={true}
              orientation="left"
              customLogo={<div style={{ padding: "8px 0" }}>logo</div>}
            >
              <AxSideMenu.SideMenuItem menuId="1">
                <AxIconWrapper type="regular" size="20" icon={"fa-star"} />
              </AxSideMenu.SideMenuItem>
              <AxSideMenu.SideMenuItem menuId="2">
                <AxIconWrapper type="regular" size="20" icon={"fa-star"} />
              </AxSideMenu.SideMenuItem>
            </AxSideMenu>
          </div>
        </Space>
      </div>
    );
  }
}
export default SideMenu;
